<template>
  <div>
    <div class="vanta-container" :id="vantaId" v-if="enabled">
      <p class="text-h4 text-sm-h3 text-md-h2 text-lg-h1 ma-2 pa-3 bg-color">
        <strong>panman</strong>'s portfolio
      </p>
      <slot />
    </div>
    <div class="vanta-container" :id="vantaId" v-else>
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  name: "VueVanta",
  props: {
    effect: {
      type: String,
      default: () => "net",
    },
    options: {
      type: Object,
      default: () => ({
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.0,
        minWidth: 200.0,
        scale: 1.0,
        scaleMobile: 1.0,
        color: 0x3f99ff,
        backgroundColor: 0xf5f5f5,
        points: 20.00,
        maxDistance: 24.0,
        spacing: 16.0,
      }),
    },
    src: {
      type: String,
      default: () => "https://cdn.jsdelivr.net/gh/tengbao/vanta@master/dist",
    },
    vantaId: {
      type: String,
      default: () => "vanta-1",
    },
    enabled: {
      type: Boolean,
      default: () => true,
    },
    threeVersion: {
      type: Number,
      default: () => 101,
    },
  },
  beforeMount() {
    if (this.enabled) {
      this.setup();
    }
  },
  methods: {
    setup() {
      // Normalize the url
      const normalize = (string) =>
        string.substr(-1) === "/"
          ? string.substr(0, string.length - 1)
          : string;
      const url = normalize(this.src);

      // Create the script for threejs
      const threejs = document.createElement("script");
      threejs.async = true;
      threejs.defer = true;
      threejs.id = "three";
      threejs.src = `https://cdnjs.cloudflare.com/ajax/libs/three.js/${this.threeVersion}/three.min.js`;
      document.head.appendChild(threejs);

      // Create the script for Vanta
      threejs.onload = () => {
        const vantaScript = document.createElement("script");
        vantaScript.async = true;
        vantaScript.defer = true;
        vantaScript.id = "vanta";
        vantaScript.src = `${url}/vanta.${this.effect}.min.js`;
        document.head.appendChild(vantaScript);
        vantaScript.onload = () => {
          window.VANTA[this.effect.toUpperCase()](
            Object.assign(this.options, {
              el: `#${this.vantaId}`,
            })
          );
        };
      };
    },
  },
};
</script>

<style scoped>
.vanta-container {
  height: 714px;
}
.bg-color {
  background-color:rgba(44, 155, 255, 0.5) !important;
  border-radius: 10px;
}
</style>

